import { StandardAsset } from '$components/Asset';
import cn from 'classnames';
import { HTMLAttributes, useEffect, useState } from 'react';

import { IProductSlideAsset } from './';

export function ProductImage(
  props: IProductSlideAsset & HTMLAttributes<HTMLElement>,
) {
  const { className, assets, active, coverClass } = props;

  const [devicePixelRatio, setDevicePixelRatio] = useState(1);
  useEffect(() => {
    setDevicePixelRatio(Math.min(2, window.devicePixelRatio));
  }, []);

  return (
    <StandardAsset
      className={cn(
        className,
        //'fade-in-section',
        //active ? 'is-visible' : 'absolute',
        'duration-1000 -right-[82px] md:right-auto absolute',
        active ? 'opacity-100' : 'opacity-0',
      )}
      assets={assets}
      customClass={coverClass}
      //sizes={'(max-width: 1024px) 50vw, 33vw'}
      sizes={
        '(max-width: ' +
        Math.floor(375 * devicePixelRatio) +
        'px) ' +
        Math.floor(375 / devicePixelRatio) +
        'px, ' +
        Math.floor(512 / devicePixelRatio) +
        'px'
      }
    />
  );
}
